import { render, staticRenderFns } from "./DescriptiveSection.vue?vue&type=template&id=344a33b0&scoped=true"
import script from "./DescriptiveSection.vue?vue&type=script&lang=js"
export * from "./DescriptiveSection.vue?vue&type=script&lang=js"
import style0 from "./DescriptiveSection.vue?vue&type=style&index=0&id=344a33b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a33b0",
  null
  
)

export default component.exports